const SESSION_PREFIX = 'bringy-pv:';

export function trackPageView({ path, locale }) {
  if (typeof window === 'undefined') return;
  if (!path || path.startsWith('/admin')) return;

  const key = `${SESSION_PREFIX}${path}`;
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, '1');

  const payload = {
    path,
    locale: locale || document.documentElement.lang || undefined,
    referrer: document.referrer || undefined,
  };

  fetch('/api/analytics/pageview', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
}
